import { buildTableOptions } from "../../../utils/tableOptions";
import { convertDateTimeToLocaleV2 } from "../../../hooks/General";
import ApiService from "../../../utils/apiServices";
import { rest_api_url } from "../../../constants/urls";
import { fetchListData } from "../../../utils/fetchListData";

export const fetchReportsGeneration = async ({
  query_parameters,
  setReportGenerationData,
  setTotalCount,
  setTotalPages,
  sortField,
  sortDirection,
  setHasNextPage,
  setFilterLoading,
  alert_notify,
}) => {
  setFilterLoading(true);
  fetchListData({
    apiUrl: rest_api_url.back_office_generated_reports,
    buildUrl: ({ apiUrl }) => {
      let url = `${apiUrl}?${query_parameters}`;
      if (sortField) url += `&sortField=${encodeURIComponent(sortField)}`;
      if (sortDirection) url += `&sortOrder=${encodeURIComponent(sortDirection)}`;
      return url;
    },
    alert_notify,
    onSuccess: (response) => {
      const { reports: reportList, pagination } = response;

      if (!Array.isArray(reportList)) {
        throw new Error("Unexpected response format: Expected an array of reports.");
      }

      const processedReportList = reportList.map((item) => ({
        ...item,
        date: convertDateTimeToLocaleV2(item.created_at),
      }));

      setReportGenerationData(processedReportList);
      setTotalCount(pagination.totalRecords);
      setTotalPages(pagination.totalPages);
      setHasNextPage(pagination.page < pagination.totalPages);
      setFilterLoading(false);
    },
    onError: (err) => {
      setFilterLoading(false);
      alert_notify("error", err?.message || "Something went wrong while fetching reports.");
    },
  });
};

export const updateSingleReportInList = ({
  reportList,
  reportGenerationID,
  updatedFields = {},
  convertDate = false,
}) => {
  if (!Array.isArray(reportList)) return reportList;

  return reportList.map((report) => {
    if (report.id === reportGenerationID) {
      return {
        ...report,
        ...updatedFields,
        ...(convertDate && updatedFields.created_at
          ? { date: convertDateTimeToLocaleV2(updatedFields.created_at) }
          : {}),
      };
    }
    return report;
  });
};

export const fetchReportDownloadUrl = async ({ reportId, alert_notify }) => {
  try {
    const url = `${rest_api_url.back_office_generated_reports}/${reportId}`;

    const response = await new Promise((resolve, reject) => {
      ApiService.get(url, resolve, reject, true);
    });

    const downloadUrl = response?.url;

    if (!downloadUrl) {
      throw new Error("Download URL not available.");
    }

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", response?.filename || "report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return {
      status: true,
      url: downloadUrl,
    };
  } catch (error) {
    alert_notify("error", error.message || "Failed to fetch download link.");
    return {
      status: false,
      message: error.message,
    };
  }
};

export const reportGenerationListTableOptions = ({
  currentPage,
  handlePageChange,
  handleRowsPerPageChange,
  handleSortChange,
  filterLoading,
  totalCount,
  rowPerPage
}) =>
  buildTableOptions({
    page: currentPage,
    onChangePage: handlePageChange,
    onChangeRowsPerPage: handleRowsPerPageChange,
    onColumnSortChange: handleSortChange,
    loading: filterLoading,
    count: totalCount,
    rowsPerPage: rowPerPage,
});
